import { RouterPaths } from '@/app/router'

type Redirect = (p: { showOnly: string; activeTabs: string }) => void
export const redirect: Redirect = ({ showOnly, activeTabs }) => {
  // TODO: add metric to know which clients should migrate to v2

  const { pathname } = window.location

  if (Object.values(RouterPaths).includes(pathname as RouterPaths)) {
    return
  }

  let newPathname = RouterPaths.STATUS
  if (showOnly === 'steps') {
    newPathname = RouterPaths.STEPS
  }
  if (showOnly === 'map') {
    newPathname = RouterPaths.MAP
  }
  if (activeTabs === 'chatTab') {
    newPathname = RouterPaths.CHAT
  }

  window.location.replace(
    `${window.location.origin}${newPathname}${window.location.search}`
  )
}
